import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@knockrentals/knock-shared-web-v2';

const SocialUrl = ({
  clearFieldErrorMessage,
  endIcon,
  id,
  label,
  name,
  readOnly,
  startIcon,
  updateSocial,
  validationErrorMessage,
  value,
}) => {
  const handleOnBlur = (e) => {
    if (readOnly) {
      return;
    }
    const { name, value } = e.target;
    updateSocial({ [name]: value.trim() });
  };

  const handleOnChange = (_value, e) => {
    const { name, value: inputValue } = e.target;
    updateSocial({ [name]: inputValue });
  };

  const handleOnFocus = (e) => {
    if (readOnly) {
      return;
    }

    const { name } = e.target;
    if (validationErrorMessage) {
      clearFieldErrorMessage(name);
    }
  };

  return (
    <TextField
      endIcon={endIcon}
      error={Boolean(validationErrorMessage)}
      fullWidth
      helperText={validationErrorMessage}
      id={`${id || name}-url`}
      label={label}
      name={name}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      readOnly={readOnly}
      startIcon={startIcon}
      value={value}
      variant="outlined"
    />
  );
};

SocialUrl.propTypes = {
  clearFieldErrorMessage: PropTypes.func,
  endIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  startIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  updateSocial: PropTypes.func,
  validationErrorMessage: PropTypes.string,
  value: PropTypes.string,
};

export default SocialUrl;
